<template>
  <div>
    <a-spin :spinning="spinning">
    <FullCalendar
        class='neo-admin-calendar'
        ref="fullCalendar"
        :eventTextColor="eventTextColor"
        defaultView="dayGridMonth"
        :header="{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        }"
        :plugins="calendarPlugins"
        :weekends="true"
        :displayEventTime="true"
        :events="calendarEvents"
        @dateClick="handleDateClick"
        @eventClick="handleEventClick"
        :datesRender="handleDatesChange"
    />
    </a-spin>

  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

import { makeEventData } from './data'

import moment from 'moment'

export default {
  name: 'CalendarView',
  components: {
    FullCalendar,
  },
  props: {
    rolesetting: { type: Object },
  },
  mounted: function() {
    this.getCalendarData()
    this.$eventBus.$on('calendarEventUpdated', this.getCalendarData)
  },
  data: function() {
    return {
      spinning: true,
      visible: false,

      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
      ],
      calendarEvents: [],
      eventTextColor: '#f3f3f3',

      hoveredCalendarEvent: {},
    }
  },
  methods: {
    getCalendarData() {
      this.spinning = true

      let calendarApi = this.$refs.fullCalendar.getApi()
      let calendarViewStartDate = moment(calendarApi.view.currentStart).format('YYYY-MM-DD')
      let calendarViewEndDate = moment(calendarApi.view.currentEnd).format('YYYY-MM-DD')

      this.$http.get('/api/calendar', {
        params: {
          start_date: calendarViewStartDate,
          end_date: calendarViewEndDate,
        },
      }).then(({ data }) => {
        this.calendarEvents = makeEventData(data.data)
        this.spinning = false
      })
    },
    handleDateClick(arg) {
      if (!moment(arg.date).isBefore(moment(), 'day')) {
        // this.$refs.calendarAddEvent.showModal(arg.date)
        this.$eventBus.$emit('openCalendarEventAddModal', arg.date)
      } else {
        this.$message.warning('Adding events on past date is disabled!')
      }
    },
    handleEventClick(arg) {
      if (!this.rolesetting.insertable) {
        return
      }
      if (!moment(arg.event.start).isBefore(moment(), 'day')) {
        // this.$refs.calendarEditEvent.showModal(arg.event)
        if (!this.rolesetting.insertable) return
        this.$eventBus.$emit('openCalendarEventEditModal', arg.event)
      } else {
        if (!this.rolesetting.editable) return
        // this.$refs.calendarSingleEvent.showModal(arg.event)
        this.$eventBus.$emit('openCalendarEventSingleViewModal', arg.event)
        this.$message.warning('Editing events on past date is disabled!')
      }
    },
    handleDatesChange(arg) {
      this.getCalendarData()
    },
  },
}
</script>
<style lang='scss'>

@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';

.fc-button-primary {
  background-color: var(--theme-primary-color, #1b55e3);
  border-color: var(--theme-primary-color, #1b55e3);
}
.fc-button-primary:hover {
  background-color: var(--theme-primary-color, #1b55e3);
  border-color: var(--theme-primary-color, #1b55e3);
  background-image: url(/resources/images/translucent_overlay.png);
}
.fc-today-button{
  background-color: #1a252f;
  border-color: #151e27;
}
.fc-today-button:hover{
  background-color: #1a252f;
    border-color: #151e27;
}

</style>
